// Funzione che crea il pdf con tutto il dettaglio di una serie di carte e/o prodotti sigillati
import {jsPDF} from "jspdf";
import 'svg2pdf.js'
import {
  compareStrings,
  displayTranslations, groupByAndKeepOrder, parseLanguage,
  titleize
} from "../utils";
import 'jspdf-autotable'
import I18n from 'i18n.js.erb'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";


const tab = "        "
const space = " "

const writeBoldText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const addFooters = (doc) => {
  const pageCount = doc.internal.getNumberOfPages()

  doc.setFont('helvetica', 'italic')
  doc.setFontSize(7)

  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.text('Page ' + String(i) + ' of ' + String(pageCount), doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, {
      align: 'center'
    })
  }
}



const getTableRow = (blueprintImage, displayCollectorNumber, displayRarity, displayVersion, displayLanguage) => {

  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)

  var name = blueprintImageNames[0]
  if(blueprintImageNames.length > 1){
    name = blueprintImageNames[0] + ' (' +
      blueprintImageNames[1] + ')'
  }

  var collectorNumber = null
  if(blueprintImage.collector_number){
    collectorNumber = blueprintImage.collector_number.replaceAll(' ', '')
  }

  var rarity = null
  if (blueprintImage.rarity) {
    rarity = titleize(blueprintImage.rarity)
  }

  var version = null
  if (blueprintImage.version) {
    version = titleize(blueprintImage.version)
  }

  var language = null
  if (blueprintImage.language_filter) {
    language = parseLanguage(blueprintImage.language_filter)
  }

  const row = [name]
  if (displayCollectorNumber)
    row.push(collectorNumber)
  if (displayRarity)
    row.push(rarity)
  if (displayVersion)
    row.push(version)
  if (displayLanguage)
    row.push(language)

  return row
}



async function displayTable (doc, blueprintImages, startingYPosition, filters) {
  const firstBlueprintImage = blueprintImages[0]
  var expansionName = ''

  const expansionNames = displayTranslations(firstBlueprintImage.en_expansion_name, firstBlueprintImage.expansion_name, firstBlueprintImage.language)
  if (firstBlueprintImage.expansion && !firstBlueprintImage.expansion.is_fake) {
    expansionName = expansionNames[0]
    if(expansionNames.length > 1){
      expansionName = expansionNames[0] + ' (' +
        expansionNames[1] + ')'
    }
  }

  const edition = firstBlueprintImage.edition
  if (edition && !compareStrings(edition, 'undefined') &&
    expansionName.toLowerCase().indexOf(edition.toLowerCase()) === -1 &&
    !(edition.toLowerCase() === '1 edition' && (
      expansionName.toLowerCase().indexOf('1st edition') > -1 ||
      expansionName.toLowerCase().indexOf('1a edizione') > -1 ||
      expansionName.toLowerCase().indexOf('1 edition') > -1 ||
      expansionName.toLowerCase().indexOf('1 edizione') > -1 ||
      expansionName.toLowerCase().indexOf('1st') > -1 ||
      expansionName.toLowerCase().indexOf('1a') > -1 ||
      expansionName.toLowerCase().indexOf('1ed') > -1
    ))) {
    expansionName += ' - ' + edition
  }

    if (firstBlueprintImage.copyright)
    expansionName += ', ' + firstBlueprintImage.copyright


  let y = startingYPosition
  if (doc.internal.pageSize.height - (startingYPosition + 6 + 10) < 20) {
    doc.addPage();
    y = 14 // Restart height position
  }

  if (firstBlueprintImage.expansion.icon_url) {
    const icon = await fetch(firstBlueprintImage.expansion.icon_url);
    const svgText = await icon.text();

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
    const svgElement = svgDoc.documentElement;

    await doc.svg(svgElement, {x: 10, y: y, width: 6, height: 6});
  }

  doc.autoTable({
    theme: 'plain',
    body: [[expansionName]],
    margin: {left: 16, right: 10},
    startY: y,
    bodyStyles: {
      font: 'Koruri-Regular',
      fontSize: 8,
      fontWeight: 'bold',
      lineWidth: 0.0,
      lineColor: [0, 0, 0],
      align: 'center'
    }
  })


  const displayCollectorNumber = displayBlueprintImageColumn(blueprintImages, 'collector_number', filters, 'collector_number')
  const displayRarity = displayBlueprintImageColumn(blueprintImages, 'rarity', filters, 'rarity')
  const displayVersion = displayBlueprintImageColumn(blueprintImages, 'version', filters, 'version')
  const displayLanguage = displayBlueprintImageColumn(blueprintImages, 'language_filter', filters, 'language')

  doc.setFontSize(8)
  var tableContent = []
  for (var i = 0; i < blueprintImages.length; i++) {
    tableContent.push(getTableRow(blueprintImages[i], displayCollectorNumber, displayRarity, displayVersion, displayLanguage))
  }


  const head = [
    I18n.t('js.PDFGenerator.common.tableHeader.name')
  ]

  if (displayCollectorNumber)
    head.push(I18n.t('js.PDFGenerator.common.tableHeader.collector_number'))
  if (displayRarity)
    head.push(I18n.t('js.PDFGenerator.common.tableHeader.rarity'))
  if (displayVersion)
    head.push(I18n.t('js.PDFGenerator.common.tableHeader.version'))
  if (displayLanguage)
    head.push(I18n.t('js.PDFGenerator.common.tableHeader.languageFilter'))

  doc.autoTable({
    theme: 'plain',
    head: [head],
    body: tableContent,
    margin: {left: 10, right: 10},
    startY: doc.lastAutoTable.finalY,
    headStyles: {
      font: 'Koruri-Bold',
      fontSize: 8,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      align: 'center'
    },
    bodyStyles: {
      font: 'Koruri-Regular',
      fontSize: 8,
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      align: 'center'
    },
    columnStyles: {
      1: {cellWidth: 28}
    },
    alternateRowStyles: {
      fillColor: [230, 230, 230]
    }
  })
}


const displayBlueprintImageColumn = (blueprintImages, attribute, filters, filterKey) => {
  for (const blueprintImage of blueprintImages) {
    if (blueprintImage[attribute] && (!filters[filterKey] || blueprintImage[attribute] !== filters[filterKey]))
      return true;
  }
  return false;
}


const getValueName = (values, value, filterName) => {
  for (const val of values) {
    if (['game_id', 'category_id', 'encasing_id'].includes(filterName)) {
      if (val[1] == value)
        return val[0];
    } else if (['era_id', 'expansion_id'].includes(filterName)) {
      if (val.id == value)
        return val.name;
    }
  }
  return null
}


export async function blueprintImagesCompactPDF (blueprintImagesCount, blueprintImages, filters, available_options_for_select) {

  const doc = new jsPDF({orientation: "portrait"});
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')
  var img = new Image()
  img.src = '/images/square.png'
  doc.addImage(img, 'png', 10, 1, 15, 15)
  doc.setFontSize(14)
  writeBoldText(doc, I18n.t('js.PDFGenerator.blueprintImages.title'), 28, 13)
  doc.setFontSize(10)
  writeBoldText(doc, I18n.t('js.PDFGenerator.blueprintImages.activeFilters') + ':', 12, 28)

  const filtersContent = []
  Object.entries(filters).forEach(([fieldName, fieldValue]) => {
    if (fieldValue && !['release_year', 'release_month', 'release_day', 'sort_by', 'sorting_direction'].includes(fieldName)) {
      let filterName = (I18n.t(`js.PDFGenerator.blueprintImages.filters.${fieldName}`).indexOf('missing') === -1 ? I18n.t(`js.PDFGenerator.blueprintImages.filters.${fieldName}`) : titleize(fieldName).replaceAll('_', ' '))

      let filterValue = fieldValue
      if (fieldName === 'game_id')
        filterValue = getValueName(available_options_for_select.games, fieldValue, fieldName)
      else if (fieldName === 'category_id')
        filterValue = getValueName(available_options_for_select.categories, fieldValue, fieldName)
      else if (fieldName === 'encasing_id')
        filterValue = getValueName(available_options_for_select.all_encasings, fieldValue, fieldName)
      else if (fieldName === 'era_id')
        filterValue = getValueName(available_options_for_select.eras, fieldValue, fieldName)
      else if (fieldName === 'expansion_id')
        filterValue = getValueName(available_options_for_select.expansions, fieldValue, fieldName)
      else if (['rarity', 'version', 'language', 'edition'].includes(fieldName))
        filterValue = titleize(filterValue)
      if (filterValue && filterValue.toString().toLowerCase() === 'true')
        filterValue = 'YES'
      else if (filterValue && filterValue.toString().toLowerCase() === 'false')
        filterValue = 'NO'

      if (filterValue) {
        filtersContent.push([filterName + ': ', filterValue])
      }
    }
  })
  filtersContent.push([I18n.t('js.PDFGenerator.blueprintImages.productsCount') + ': ', blueprintImagesCount])

  doc.autoTable({
    theme: 'plain',
    body: filtersContent,
    margin: {left: 10, right: 10},
    startY: 30,
    bodyStyles: {
      font: 'Koruri-Regular',
      fontSize: 8,
      lineWidth: 0.0,
      align: 'left'
    },
    columnStyles: {
      0: {cellWidth: 30},
      1: {cellWidth: doc.internal.pageSize.width - 30}
    }
  })

  let groupedBlueprintImages = groupByAndKeepOrder(blueprintImages, 'expansion_id')

  let initialPosition = doc.lastAutoTable.finalY + 3

  for (const blueprintImagesByExpansion of groupedBlueprintImages) {
    await displayTable(doc, blueprintImagesByExpansion, initialPosition, filters)
    initialPosition = doc.lastAutoTable.finalY + 2
  }

  addFooters(doc)
  var pdfName= 'products.pdf'
  doc.save(pdfName);
}
